import {
  BarcodeIcon,
  CashIcon,
  CreditCardIcon,
  ExternalLinkIcon,
  MoneyIcon,
  PixIcon,
  TransferPesoIcon,
  WalletIcon,
} from '@nimbus-ds/icons';
import {
  PaymentMethodType,
  PaymentProviderDto,
  PlansListResponseDto,
} from '@tiendanube/common';
import { PaymentProvidersCode } from '@tiendanube/common/src/domains/payments/providers/PaymentProvidersCode';
import { Country } from '@tiendanube/common/src/enums';

export const isLastItem = (list: Array<any>, index: number) =>
  index + 1 === list.length;

export const TRANSLATE_PAYMENT_PREFIX = 'paymentRatesCard';

interface PaymentProvidersByStatus {
  enabled: PaymentProviderDto[];
  disabled: PaymentProviderDto[];
  pending: PaymentProviderDto[];
}

export const getProvidersByStatus = (paymentProviders: PaymentProviderDto[]) =>
  paymentProviders.reduce<PaymentProvidersByStatus>(
    (acc, paymentProvider) => {
      const { mustCompleteInstallation, isActive, processingInstallation } =
        paymentProvider;
      if (!mustCompleteInstallation && isActive && !processingInstallation) {
        acc.enabled.push(paymentProvider);
      } else if (
        !mustCompleteInstallation &&
        !isActive &&
        !processingInstallation
      ) {
        acc.disabled.push(paymentProvider);
      } else if (mustCompleteInstallation || processingInstallation) {
        acc.pending.push(paymentProvider);
      }
      return acc;
    },
    {
      enabled: [],
      disabled: [],
      pending: [],
    },
  );

export const recategorizePendingNuvemPagoAsEnabled = (
  providersByStatus: PaymentProvidersByStatus,
): PaymentProvidersByStatus => {
  const { disabled, enabled, pending } = providersByStatus;

  const nuvemPagoBrProvider = pending.find(
    ({ id }) => id === PaymentProvidersCode.nuvemPago,
  );

  if (!nuvemPagoBrProvider) return providersByStatus;

  return {
    disabled,
    enabled: [...enabled, nuvemPagoBrProvider],
    pending: pending.filter(({ id }) => id !== PaymentProvidersCode.nuvemPago),
  };
};

export const PAYMENT_METHOD_TYPE_ICONS: Record<PaymentMethodType, React.FC> = {
  creditCard: CreditCardIcon,
  debitCard: CreditCardIcon,
  creditAndDebitCard: CreditCardIcon,
  wallet: WalletIcon,
  wireTransfer: TransferPesoIcon,
  cash: CashIcon,
  offline: CashIcon,
  bankDebit: CreditCardIcon,
  boleto: BarcodeIcon,
  pix: PixIcon,
  ticket: BarcodeIcon,
  other: MoneyIcon,
  custom: MoneyIcon,
  redirect: ExternalLinkIcon,
  modal: ExternalLinkIcon,
};

export const PAYMENT_METHOD_CHECKOUT_TYPE_ICONS: Record<
  PaymentMethodType,
  React.FC
> = {
  ...PAYMENT_METHOD_TYPE_ICONS,
  cash: TransferPesoIcon,
  ticket: TransferPesoIcon,
  other: TransferPesoIcon,
  wallet: TransferPesoIcon,
};

export const providersShowingLabels = [
  { provider: 'primefy', labels: ['creditCard', 'boleto', 'pix'] },
];

interface GetCustomPaymentsCpt {
  cpt: number;
  currentPlanLevel: number;
  storeCountry: Country;
  plansList: PlansListResponseDto[];
  isFreePlan: boolean;
  ifOther: boolean;
  isEnterprisePlan: boolean;
}

export const getCustomPaymentsCpt = ({
  cpt,
  ifOther,
  isFreePlan,
  plansList,
  storeCountry,
  currentPlanLevel,
  isEnterprisePlan,
}: GetCustomPaymentsCpt) => {
  const planA = plansList.find(({ level }) => level === 1);
  const planB = plansList.find(({ level }) => level === 2);

  if (
    (storeCountry === 'AR' || storeCountry === 'BR') &&
    ifOther &&
    isFreePlan
  ) {
    return planA?.fee.value;
  }

  if (!ifOther && currentPlanLevel < 2 && !isEnterprisePlan) {
    return planB?.fee.value;
  }

  return cpt;
};
